import { HiveText } from './nodes/hive-text';

export function effects() {
  customElements.define('hive-text', HiveText);
}

declare global {
  interface HTMLElementTagNameMap {
    'hive-text': HiveText;
  }
}
